import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ scrollY }) => {
  const parallaxOffset = scrollY * 0.5;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background" style={{ transform: `translateY(${parallaxOffset}px)` }}>
        <img
          src="https://images.unsplash.com/photo-1760553120312-2821bf54e767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzbWFydCUyMGNpdHklMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3MTcyODk3N3ww&ixlib=rb-4.1.0&q=85"
          alt="Smart City Technology"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="hero-text-container">
          <h1 className="hero-title">
            Empowering the Future
          </h1>
          <h2 className="hero-subtitle">
            Sygmatec Smart Solutions
          </h2>
          <p className="hero-description">
            Advanced technological frameworks designed to create safer, more efficient, 
            and hyper-connected environments through cutting-edge hardware and intelligent software.
          </p>
          <button className="btn-primary hero-cta" onClick={() => scrollToSection('solutions')}>
            Explore Solutions
            <ArrowRight size={20} />
          </button>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Hero;
